<template>
  <div class="warn">
    <transition name="slide-fade">
      <router-view></router-view>
    </transition>
    <img class="warn-icon" src="../../../assets/content-box.png"/>
  </div>
</template>

<script>
export default {
  name: 'Warn'
}
</script>

<style scoped>
  @import "Warn.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/warn/Warn.vue